import type { DocumentTemplateVersionDetailPayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';

// The `200` response is the updated version detail, declaration included.
export type DocumentTemplateVersionSectionsUpdatedPayload = DocumentTemplateVersionDetailPayload;

export type DocumentTemplateVersionSectionsUpdatedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_SECTIONS_UPDATED';
	payload: DocumentTemplateVersionSectionsUpdatedPayload;
};

export default (
	payload: DocumentTemplateVersionSectionsUpdatedPayload,
): DocumentTemplateVersionSectionsUpdatedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_SECTIONS_UPDATED',
	payload,
});
